import {
  type DataPayload,
  type MessagingChatAuth,
} from 'types/customEventData';

export abstract class AbstractChatClient {
  abstract addTags(tags?: string[] | null): Promise<void> | void;

  abstract identify(
    payload?: DataPayload['visitor_info'] | MessagingChatAuth,
  ): Promise<void> | void;

  abstract logout(): Promise<void> | void;

  abstract hideWidget(): Promise<void> | void;

  abstract openWidget(): void;
}
